import { z } from 'zod';
import { ZAbTastyIntegrationConfig } from './ab-tasty.js';
import { ZAddingwellIntegrationConfig } from './addingwell.js';
import { ZAnalyzifyIntegrationConfig } from './analyzify.js';
import { ZAtlasIntegrationConfig } from './atlas.js';
import { ZColissimoPickupPointIntegrationConfig } from './colissimo-pickup-point.js';
import { ZContentsquareIntegrationConfig } from './contentsquare.js';
import { ZDefaultDatalayerIntegrationConfig } from './default-datalayer.js';
import { ZElevarIntegrationConfig } from './elevar.js';
import { ZFacebookIntegrationConfig } from './facebook.js';
import { ZGoogleIntegrationConfig } from './google.js';
import { ZHeyPongoIntegrationConfig } from './hey-pongo.js';
import { ZLoyolyIntegrationConfig } from './loyoly.js';
import { ZMondialRelayIntegrationConfig } from './mondial-relay.js';
import { ZPinterestIntegrationConfig } from './pinterest.js';
import { ZSendcloudIntegrationConfig } from './sendcloud.js';
import { ZSnapchatIntegrationConfig } from './snapchat.js';
import { ZStapeIntegrationConfig } from './stape.js';
import { ZTagInstallIntegrationConfig } from './tag-install.js';
import { ZTiktokIntegrationConfig } from './tiktok.js';
import { ZYotpoIntegrationConfig } from './yotpo.js';
export const ZShopIntegrationConfig = z.discriminatedUnion('integrationName', [
    ZYotpoIntegrationConfig,
    ZHeyPongoIntegrationConfig,
    ZLoyolyIntegrationConfig,
    ZColissimoPickupPointIntegrationConfig,
    ZAtlasIntegrationConfig,
    ZAddingwellIntegrationConfig,
    ZGoogleIntegrationConfig,
    ZFacebookIntegrationConfig,
    ZTiktokIntegrationConfig,
    ZPinterestIntegrationConfig,
    ZSnapchatIntegrationConfig,
    ZDefaultDatalayerIntegrationConfig,
    ZAbTastyIntegrationConfig,
    ZContentsquareIntegrationConfig,
    ZElevarIntegrationConfig,
    ZTagInstallIntegrationConfig,
    ZAnalyzifyIntegrationConfig,
    ZStapeIntegrationConfig,
    ZSendcloudIntegrationConfig,
    ZMondialRelayIntegrationConfig,
]);
/**
 * Type guard: narrows a shop integration to the loyalty providers.
 *
 * @example
 * const loyalty = shop.integrations?.find(
 *   (i): i is LoyaltyIntegrationConfig => isLoyaltyIntegrationConfig(i) && i.status === 'active',
 * );
 */
export function isLoyaltyIntegrationConfig(integration) {
    return integration.category === 'loyalty';
}
export * from './ab-tasty.js';
export * from './addingwell.js';
export * from './analyzify.js';
export * from './atlas.js';
export * from './base.js';
export * from './colissimo-pickup-point.js';
export * from './contentsquare.js';
export * from './default-datalayer.js';
export * from './elevar.js';
export * from './facebook.js';
export * from './google.js';
export * from './hey-pongo.js';
export * from './loyoly.js';
export * from './mondial-relay.js';
export * from './pinterest.js';
export * from './registry.js';
export * from './sendcloud.js';
export * from './snapchat.js';
export * from './stape.js';
export * from './tag-install.js';
export * from './tiktok.js';
export * from './yotpo.js';
//# sourceMappingURL=index.js.map